export default {
  invoice: "Rechnungen",
  contract: "Verträge",
  offer: "Angebot",
  insurance: "Versicherungen",
};
